import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const DataDeletion: React.FC = () => {
  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Data Deletion" pagesub="Data Deletion" />
            <section className="legal-content pt-120 pb-120">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="legal-content-wrap">
                      <div className="sec-title sec-title-center about-sec-title about-sec-title-two mb-60">
                        <span className="sub-title mb-10">Legal</span>
                        <h2 className="title">Data Deletion Request</h2>
                      </div>

                      <p className="legal-meta" style={{ textAlign: "center", color: "rgba(255,255,255,0.5)", marginBottom: 60 }}>
                        Last updated: May 10, 2026
                      </p>

                      <div className="legal-section">
                        <h3 className="legal-heading">1. Your Right to Delete</h3>
                        <p className="legal-text">
                          TorqAI Technologies Inc. ("TorqAI," "we," "us," or "our") respects your right to control the
                          personal data we hold about you. You may request that we permanently delete any personal
                          information collected through our website at torqai.ca, our AI agents (CAPRO, VAPRO, HAPRO,
                          SAPRO, TAPRO, and INPRO), or any login flow that uses Facebook or another third-party identity
                          provider.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">2. What Data Can Be Deleted</h3>
                        <p className="legal-text">
                          A deletion request will remove the following information from our production systems:
                        </p>
                        <ul className="legal-list">
                          <li><strong>Account Information:</strong> Name, email address, phone number, company name, billing
                            address, and any profile details you provided to us.</li>
                          <li><strong>Authentication Data:</strong> Any Facebook user ID, OAuth tokens, or third-party login
                            identifiers we received during sign-in.</li>
                          <li><strong>Conversation &amp; Interaction Data:</strong> Chat transcripts, voice call recordings
                            handled by CAPRO, social posts generated by VAPRO, candidate notes from HAPRO, sales
                            interactions from SAPRO, training simulations from TAPRO, and analytics events from INPRO.</li>
                          <li><strong>Usage &amp; Device Data:</strong> Session logs, IP addresses, browser fingerprints, and
                            cookies tied to your account.</li>
                        </ul>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">3. How to Request Deletion</h3>
                        <p className="legal-text">
                          You can request deletion of your data in any of the following ways:
                        </p>
                        <ul className="legal-list">
                          <li><strong>Email:</strong> Send a deletion request to{" "}
                            <a href="mailto:info@torqai.ca?subject=Data%20Deletion%20Request" style={{ color: "var(--color-primary)" }}>
                              info@torqai.ca
                            </a>{" "}
                            with the subject line "Data Deletion Request". Please include the email address or phone
                            number associated with your account so we can locate it.</li>
                          <li><strong>Contact Form:</strong> Use the form on our{" "}
                            <a href="/contact" style={{ color: "var(--color-primary)" }}>Contact</a> page and select "Data Deletion" as the
                            subject.</li>
                          <li><strong>Facebook Login Users:</strong> If you signed in using Facebook, you can also revoke
                            TorqAI's access from your Facebook account settings under{" "}
                            <em>Settings &gt; Apps and Websites</em>. After revoking access, please email us so we can
                            erase the data we have already collected.</li>
                        </ul>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">4. Processing Timeline</h3>
                        <p className="legal-text">
                          We will acknowledge your request within 5 business days and complete the deletion within 30
                          calendar days. Once deletion is complete, we will send a confirmation email to the address on
                          file. If we are unable to honour the request (for example, where retention is required by law
                          or to resolve a billing dispute), we will explain why and how long the relevant data will be
                          retained.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">5. What Is Retained</h3>
                        <p className="legal-text">
                          For legal, accounting, and security reasons we may retain a limited set of records after a
                          deletion request, including:
                        </p>
                        <ul className="legal-list">
                          <li>Invoices and tax records required by Canadian and provincial law.</li>
                          <li>Anonymised, aggregated analytics that no longer identify you.</li>
                          <li>Backup snapshots, which are purged on our standard rolling 90-day cycle.</li>
                          <li>Records that we are legally compelled to keep in response to a court order or regulator.</li>
                        </ul>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">6. Children's Data</h3>
                        <p className="legal-text">
                          TorqAI is not intended for use by anyone under the age of 16. If you believe a child's data has
                          been collected, contact us and we will delete it immediately upon verification.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">7. Contact Us</h3>
                        <p className="legal-text">
                          Questions about this policy or the status of a deletion request can be sent to:
                        </p>
                        <p className="legal-text">
                          <strong>TorqAI Technologies Inc.</strong><br />
                          30 Charles St W, Toronto, ON, Canada<br />
                          Email:{" "}
                          <a href="mailto:info@torqai.ca" style={{ color: "var(--color-primary)" }}>info@torqai.ca</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default DataDeletion;
